import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import {
    AVAILABLE_EXPORTS_LOAD,
    AVAILABLE_EXPORTS_SUCCESS,
    AVAILABLE_EXPORTS_FAILURE,
    FETCH_BINARY_FAILURE,
    FETCH_BINARY_LOAD,
    FETCH_BINARY_SUCCESS
} from './exportsActions';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case AVAILABLE_EXPORTS_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false,
                count: 0,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;

        case AVAILABLE_EXPORTS_LOAD:
            newState = {
                ...state,
                error: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case AVAILABLE_EXPORTS_SUCCESS:
            newState = {
                ...state,
                loading: false,
                exportsAvailable: action.exportsAvailable,
                count: action.count,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case FETCH_BINARY_FAILURE:
            newState = {
                ...state,
                error: action.error
            };

            return isEqual(state, newState) ? state : newState;

        case FETCH_BINARY_LOAD:
            newState = {
                ...state,
                error: null
            };

            return isEqual(state, newState) ? state : newState;

        case FETCH_BINARY_SUCCESS:
            newState = {
                ...state,
                fetchUrl: action.results.downloadUrl
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getExportsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'exports')
);

export const getPages = createSelector(
    getExportsEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getExportsEntity,
    (entity) => get(entity, 'count')
);

export const getExportsAvailable = createSelector(
    getExportsEntity,
    (entity) => get(entity, 'exportsAvailable')
);

export const getFetchExportCsvUrl = createSelector(
    getExportsEntity,
    (entity) => get(entity, 'fetchUrl')
);

export const getExportsAvailableError = createSelector(
    getExportsEntity,
    (entity) => get(entity, 'exportsAvailableError')
);

export const getExportsAvailableErrorMessage = createSelector(
    getExportsAvailableError,
    (error) => get(error, 'message')
);

export const getIsExportsAvailableLoading = createSelector(
    getExportsEntity,
    (entity) => get(entity, 'loading')
);

export const getExportCsvs = createSelector(
    getExportsEntity,
    (entity) => get(entity, 'ExportCsvs')
);

export const getExportCsvsObject = createSelector(
    getExportCsvs,
    (state, exportCsvId) => exportCsvId,
    (exportCsv, exportCsvId) => get(exportCsv, exportCsvId)
);

export const getExportCsvData = createSelector(
    (state, exportCsvId) => getExportCsvsObject(state, exportCsvId),
    (exportCsvsObject) => get(exportCsvsObject, 'exportCsvData')
);

export const getExportEntityError = createSelector(
    getExportsEntity,
    (entity) => get(entity, 'error')
);

export const getExportEntityErrorMessage = createSelector(
    (state) => getExportEntityError(state),
    (error) => get(error, 'message')
);
